export default "__VITE_ASSET__jkQJwPqa__"